import { render, staticRenderFns } from "./CellGridRichText.vue?vue&type=template&id=181696f2&scoped=true&"
import script from "./CellGridRichText.vue?vue&type=script&lang=js&"
export * from "./CellGridRichText.vue?vue&type=script&lang=js&"
import style0 from "./CellGridRichText.vue?vue&type=style&index=0&id=181696f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181696f2",
  null
  
)

export default component.exports